import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-slate-950 py-12 border-t border-slate-900" data-id="element-57">
        <div className="container mx-auto px-4 text-center text-slate-600 text-sm" data-id="element-58">
          <p className="mb-4" data-id="element-59">
            &copy; {new Date().getFullYear()} Protocolo Noche Tranquila 65+.
            Todos los derechos reservados.
          </p>
          <p className="mb-6" data-id="element-60">
            Este producto no sustituye el consejo médico profesional. Siempre
            consulta a un especialista.
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-61">
            <button onClick={() => setShowPrivacy(true)} className="text-slate-500 hover:text-amber-400 transition-colors underline underline-offset-2" data-id="element-62">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-63">•</span>
            <button onClick={() => setShowTerms(true)} className="text-slate-500 hover:text-amber-400 transition-colors underline underline-offset-2" data-id="element-64">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-65">
        <p data-id="element-66">
          <strong data-id="element-67">Última actualización:</strong> Febrero 2026
        </p>
        <p data-id="element-68">
          En Protocolo Noche Tranquila 65+ nos comprometemos a proteger tu
          privacidad. Esta política describe cómo recopilamos, usamos y
          protegemos tu información personal.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-69">
          1. Información que recopilamos
        </h3>
        <p data-id="element-70">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos información de tarjetas de crédito directamente; los pagos
          son procesados por plataformas seguras de terceros.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-71">
          2. Uso de la información
        </h3>
        <p data-id="element-72">
          Tu información se utiliza exclusivamente para: entregar el producto
          digital adquirido, enviar actualizaciones relacionadas con tu compra y
          brindarte soporte al cliente si lo solicitas.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-73">
          3. Protección de datos
        </h3>
        <p data-id="element-74">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-75">
          4. Compartir información
        </h3>
        <p data-id="element-76">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto los proveedores de servicios necesarios para
          procesar pagos y entregar el producto.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-77">5. Tus derechos</h3>
        <p data-id="element-78">
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento enviando una solicitud a nuestro equipo de soporte.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-79">
        <p data-id="element-80">
          <strong data-id="element-81">Última actualización:</strong> Febrero 2026
        </p>
        <p data-id="element-82">
          Al adquirir el Protocolo Noche Tranquila 65+, aceptas los siguientes
          términos y condiciones de uso.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-83">1. Producto digital</h3>
        <p data-id="element-84">
          El Protocolo Noche Tranquila 65+ es un producto digital (PDF +
          materiales imprimibles) que se entrega por correo electrónico
          inmediatamente después de la compra. No es un servicio médico ni
          sustituye la consulta profesional.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-85">2. Uso personal</h3>
        <p data-id="element-86">
          El contenido adquirido es para uso personal y familiar. Queda
          prohibida su reproducción, distribución o reventa sin autorización
          expresa.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-87">
          3. Garantía de devolución
        </h3>
        <p data-id="element-88">
          Ofrecemos una garantía de satisfacción de 14 días. Si no estás
          conforme con el producto, puedes solicitar un reembolso completo
          dentro de los 14 días posteriores a la compra, sin preguntas.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-89">
          4. Descargo de responsabilidad
        </h3>
        <p data-id="element-90">
          Este producto tiene fines educativos e informativos. No pretende
          diagnosticar, tratar ni curar ninguna condición médica. Siempre
          consulta a un profesional de la salud antes de realizar cambios en la
          rutina de sueño de una persona mayor.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-91">5. Modificaciones</h3>
        <p data-id="element-92">
          Nos reservamos el derecho de actualizar estos términos en cualquier
          momento. Los cambios serán efectivos desde su publicación.
        </p>
      </Modal>
    </>;
}